import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// ── German umlaut-aware search helpers ─────────────────────────────────
// Returns [expanded, collapsed] normalizations so that both
// "ue" and "u" style searches match umlauted data (and vice-versa).
function normalizeGerman(text: string): [string, string] {
  const lower = text.toLowerCase()
  // Two-letter expansion: ä→ae, ö→oe, ü→ue, ß→ss
  const expanded = lower
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
  // Single-letter collapse: ä→a, ö→o, ü→u, ß→ss
  const collapsed = lower
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/ü/g, 'u')
    .replace(/ß/g, 'ss')
  return [expanded, collapsed]
}

/** Case-insensitive includes() that treats German umlauts as equivalent
 *  to their ASCII counterparts (ä=a/ae, ö=o/oe, ü=u/ue, ß=ss). */
export function germanIncludes(haystack: string, needle: string): boolean {
  const [hExp, hCol] = normalizeGerman(haystack)
  const [nExp, nCol] = normalizeGerman(needle)
  return hExp.includes(nExp) || hCol.includes(nCol)
}

/** Case-insensitive startsWith() with the same German umlaut handling. */
export function germanStartsWith(haystack: string, needle: string): boolean {
  const [hExp, hCol] = normalizeGerman(haystack)
  const [nExp, nCol] = normalizeGerman(needle)
  return hExp.startsWith(nExp) || hCol.startsWith(nCol)
}

